import { useEffect, useMemo, useState } from "react";
import { FaFileAlt, FaFilePdf } from "react-icons/fa";
import { AppModal } from "../../_CORE/APP/Templates/_UI/Modal/_index";
import { AppButton } from "../../_CORE/APP/Templates/_UI/Button/_index";
import { Badge } from "../../_CORE/APP/Templates/_UI/Kit/_index";
import "./_Styles/CredentialExportPicker.css";

/*
    Selector común antes de guardar/exportar registros.
    Por seguridad, los campos sensibles empiezan desmarcados.
*/
export const CredentialExportPickerModal = ({
    isOpen = false,
    title = "Guardar / exportar",
    rows = [],
    onClose,
    onExport,
}) => {
    const [useSelection, setSelection] = useState({});
    const HAS_PASSWORD_HINT = (rows ?? []).some((row) => row.key === "passwordHint");

    useEffect(() => {
        if (!isOpen) return;
        setSelection(Object.fromEntries((rows ?? []).map((row) => [row.key, !row.isSecret])));
    }, [isOpen, rows]);

    const SELECTED_ROWS = useMemo(() => (rows ?? [])
        .filter((row) => !!useSelection[row.key])
        .map(({ label, value }) => ({ label, value })), [rows, useSelection]);

    const onSelect = (mode) => {
        if (mode === "all") {
            setSelection(Object.fromEntries((rows ?? []).map((row) => [row.key, true])));
            return;
        }
        if (mode === "safe") {
            setSelection(Object.fromEntries((rows ?? []).map((row) => [row.key, !row.isSecret])));
            return;
        }
        setSelection({});
    };

    const onRun = (format) => {
        if (!SELECTED_ROWS.length) return;
        onExport?.(format, SELECTED_ROWS);
    };

    return (
        <AppModal isOpen={isOpen} onClose={onClose} size="md"
            title={title}
            description={HAS_PASSWORD_HINT
                ? "La pista de contraseña queda incluida en el modo Para compartir. La contraseña real y los demás secretos sólo se exportan si los marcás de forma explícita."
                : "Elegí exactamente qué datos querés incluir. Los valores sensibles quedan desmarcados por defecto."}
            footer={
                <>
                    <AppButton variant="ghost" tone="neutral" onClick={onClose}>Cancelar</AppButton>
                    <AppButton variant="outline" tone="neutral" icon={<FaFileAlt />}
                        isDisabled={SELECTED_ROWS.length === 0} onClick={() => onRun("txt")}>Descargar TXT</AppButton>
                    <AppButton icon={<FaFilePdf />} isDisabled={SELECTED_ROWS.length === 0}
                        onClick={() => onRun("pdf")}>Descargar PDF</AppButton>
                </>
            }>
            <div className="LStudio__app_export_picker">
                <div className="LStudio__app_export_picker_actions">
                    <AppButton size="sm" variant="ghost" tone="neutral" onClick={() => onSelect("all")}>Todo, incluidos secretos</AppButton>
                    <AppButton size="sm" variant="ghost" tone="neutral" onClick={() => onSelect("safe")}>Para compartir</AppButton>
                    <AppButton size="sm" variant="ghost" tone="neutral" onClick={() => onSelect("none")}>Ninguno</AppButton>
                </div>

                <div className="LStudio__app_export_picker_list">
                    {(rows ?? []).map((row) => (
                        <label key={row.key} className="LStudio__app_export_picker_item">
                            <input type="checkbox" checked={!!useSelection[row.key]}
                                onChange={(event) => setSelection((current) => ({ ...current, [row.key]: event.target.checked }))} />
                            <span>{row.label}</span>
                            {row.isSecret && <Badge tone="warn" size="sm">Sensible</Badge>}
                        </label>
                    ))}
                </div>
            </div>
        </AppModal>
    );
};
